import { DocumentConnection } from '../../common/model/document-connection-base';
import { ModelBase } from '../../core/model/model-base';
import { RentalObjectDocumentType, RentalObjectDocumentTypeToString } from './const/documentEnums';

export class RentalObjectDocument extends DocumentConnection<RentalObjectDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return RentalObjectDocumentTypeToString(this.connectionType);
  }

  rentalObjectId: string;

  toJSON() {
    const result = super.toJSON();
    result['rentalObjectId'] = this.rentalObjectId;
    return result;
  }
}
